// Mirrors contract-management/server/src/utils/artifactRules.js
export const ARTIFACT_STATUS = {
  notstarted: { label: 'Not started', color: 'default' },
  draft: { label: 'Draft', color: 'processing' },
  inreview: { label: 'In review', color: 'warning' },
  approved: { label: 'Approved', color: 'success' },
  signed: { label: 'Signed', color: 'success' },
  notapplicable: { label: 'Not applicable', color: 'default' },
};

export const TRANSITIONS = {
  notstarted: ['draft', 'notapplicable'],
  draft: ['inreview', 'notapplicable'],
  inreview: ['approved', 'draft'],
  approved: ['signed', 'draft'],
  signed: ['draft'],
  notapplicable: ['notstarted'],
};

// Button text for moving an artifact from its current status to the target status.
export const TRANSITION_LABEL = {
  draft: 'Mark as draft',
  inreview: 'Submit for review',
  approved: 'Approve',
  signed: 'Mark as signed',
  notapplicable: 'Mark not applicable',
  notstarted: 'Make applicable again',
};

export const COMPLETE_STATUSES = ['approved', 'signed', 'notapplicable'];

export const ARTIFACT_GROUPS = [
  {
    key: 'pm',
    title: 'Project management',
    description: 'Delivery artifacts, grouped by phase.',
  },
];

export const ACCEPTED_FILE_TYPES = '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx';
export const MAX_FILE_SIZE_MB = 25;

export const allowedTransitions = (artifact) =>
  (TRANSITIONS[artifact.status] || []).filter(
    (status) => status !== 'signed' || artifact.requiresSignature
  );
